import CheckedIcon from "@/assets/svgs/checked-icon";
import { Pressable, Text } from "react-native";
import { useSlot, useStyled } from "use-styled";

const CheckboxInputRoot = useStyled(Pressable, {
  base: {
    className:
      "flex-1 flex-row items-center justify-between border border-gray-200 bg-teachLoop-creamLight rounded-[17] px-4 py-3 focus:outline-teal-600 ",
  },
  variants: {
    size: {},
    error: {
      true: { className: "border-red-500" },
      false: {},
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {},
  compoundVariants: [
    {
      disabled: true,
      props: {
        disabled: true,
      },
    },
  ],
});

const CheckboxLabel = useStyled(Text, {
  base: {
    className: "text-gray-800 font-geologica-regular flex-1 pr-3",
    numberOfLines: 2,
    ellipsizeMode: "tail",
  },
  variants: {
    size: {
      sm: { className: "text-sm" },
      md: { className: "text-base" },
      lg: { className: "text-lg" },
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
    size: "lg",
  },
});

const CheckboxIcon = useStyled(CheckedIcon, {
  base: {
    className: "h-5 w-5",
    pathClassName: "stroke-white",
    rectFillClassName: "fill-white",
    rectStrokeClassName: "stroke-gray-200",
  },
  variants: {
    checked: {
      true: {
        rectFillClassName: "fill-teal-500",
        rectStrokeClassName: "stroke-teal-500",
      },
      false: {},
    },
  },
  defaultVariants: {},
});

export const CheckboxInput = useSlot(CheckboxInputRoot, {
  Label: CheckboxLabel,
  Icon: CheckboxIcon,
});
